export default {
  loading: {
    text: "拼命加载中",
  },
  filters: {
    time: "时间",
    startDate: "开始时间",
    endDate: "结束时间",
    addressSearch: "地址搜索",
    searchCounterpartyAddress: "搜索交易对手地址",
    currency: "币种",
    selectCurrency: "请选择币种",
    amount: "数量",
    minAmount: "最小数量",
    maxAmount: "最大数量",
    maxAmountError: "最小数量不能大于最大数量",
    hideZeroTransactions: "隐藏数量为0的交易",
  },
  actions: {
    reset: "重置",
    query: "查询",
  },
  table: {
    totalPrefix: "共计",
    totalSuffix: "条数据",
    download: "下载",
    empty: "暂无数据",
    bigAddressEmpty: "当前地址交易过多，请筛选后查看",
    transactionHash: "交易哈希",
    sender: "发送方",
    receiver: "接收方",
    currency: "币种",
    transactionAmount: "交易数量",
    transactionTime: "交易时间",
  },
  directionOptions: {
    ALL: "全部",
    SENDER: "发送方",
    RECEIVER: "接收方",
  },
};
